import {getColor} from "@/styles/ThemeConfig";
import Image from "next/image";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";
import {useState} from "react";
import {PhotoSlider} from "@/components/city/PhotoSlider";


// Styled components for the layout
const GalleryWrapper = styled.div`
    display: flex;
    gap: 30px;
    //margin-top:-50px;
    justify-content: center;
    align-items: center;
    
    
    img{
        object-fit: cover;
        max-width: 100%;
        
        @media only screen and (${breakpoints.mobile}) {
            width: 100%;
            height: 400px;
            object-fit: cover;
        }
    }

    @media only screen and (${breakpoints.mobile}) {
        display: block;
        margin-top:0!important;
    }
`;


const ImageWrapper = styled.div`
    width: fit-content;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    &:hover {
        filter: brightness(0.7); /* Darken the image */
    }

    //.plus{
    //        position: absolute;
    //        top: 50%;
    //        left: 50%;
    //        transform: translate(-50%, -50%);
    //    font-size: 40px; /* Adjust size as needed */
    //    color: white; /* Icon color */
    //}
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: none; /* Hide by default */
        font-size: 40px; /* Adjust size as needed */
        color: white; /* Icon color */
    }

    &:hover::after {
        color: white;
        content: '+';
        display: block; /* Show on hover */
    }
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  gap: 30px;
    @media only screen and (${breakpoints.mobile}) {
        display: block;
    }
`;

const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
    @media only screen and (${breakpoints.mobile}) {
        display: block;
    }
`;

const FlexRight = styled.div`
  display: flex;
  gap: 30px;
    @media only screen and (${breakpoints.mobile}) {
        display: block;
    }
`;

const hasText = (value) => typeof value === "string" && value.trim().length > 0;

export default function CityPhotosSection({title, subtitle, photos, cityName, defaultTitle, defaultSubtitle})
{
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const cityLabel = hasText(cityName) ? cityName : "the city";
    const substitute = (value) => value.replaceAll('{city}', cityLabel);

    const globalDefaultTitle = hasText(defaultTitle) ? substitute(defaultTitle) : "Photos of our";
    const globalDefaultSubtitle = hasText(defaultSubtitle) ? substitute(defaultSubtitle) : `${cityLabel} Food Tours`;

    const displayTitle = hasText(title) ? substitute(title) : globalDefaultTitle;
    const displaySubtitle = hasText(subtitle) ? substitute(subtitle) : globalDefaultSubtitle;



    const handleOpen = (index) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };


    return <div
        className={'container_small_with_padding_20'}
        style={{
            paddingBottom: '60px',
            paddingTop: '0',
        }}
    >
        <div style={{
            padding: '20px',
        }}>
            <div style={{
                alignSelf: 'flex-start',
                marginBottom: '20px',
            }}>
                <h2 style={{
                    textTransform: 'uppercase',
                    fontSize: '26px',
                    font: 'Josefin Sans',
                    letterSpacing: '4px',
                    color: getColor('gold'),
                }}>
                    {displayTitle}
                </h2>
                <div style={{
                    textTransform: 'uppercase',
                    fontSize: '24px',
                    font: 'Josefin Sans',
                    fontWeight: 'bold',
                    color: getColor('gold'),
                }}> {displaySubtitle}</div>
            </div>


            <GalleryWrapper>
                <LeftSide>
                    <ImageWrapper onClick={() => handleOpen(0)} >
                        {/*<div className={'plus'}>+</div>*/}
                        { photos[0] && <Image
                            src={photos[0]?.url}
                            alt={photos[0]?.alt ?? photos[0]?.name}
                            width="270"
                            height="290"
                        />}
                    </ImageWrapper>

                    <ImageWrapper onClick={() => handleOpen(1)} >
                        { photos[1] && <Image
                            src={photos[1]?.url}
                            alt={photos[1]?.alt ?? photos[1]?.name}
                            width="370"
                            height="380"
                        />}
                    </ImageWrapper>
                </LeftSide>

                <RightSide>
                    <ImageWrapper onClick={() => handleOpen(2)} >
                        { photos[2] && <Image
                            src={photos[2]?.url}
                            alt={photos[2]?.alt ?? photos[2]?.name}
                            width="470"
                            height="500"
                        />}
                    </ImageWrapper>

                    <FlexRight>
                        <ImageWrapper onClick={() => handleOpen(3)} >
                            { photos[3] && <Image
                                src={photos[3]?.url}
                                alt={photos[3]?.alt ?? photos[3]?.name}
                                width="370"
                                height="410"
                            />}
                        </ImageWrapper>
                        <ImageWrapper onClick={() => handleOpen(4)} >
                            { photos[4] && <Image
                                src={photos[4]?.url}
                                alt={photos[4]?.alt ?? photos[4]?.name}
                                width="270"
                                height="270"
                            />}
                        </ImageWrapper>
                    </FlexRight>
                </RightSide>
            </GalleryWrapper>


            <PhotoSlider
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                photos={photos}
            />



        </div>
    </div>
}
